/**
 * Creates a object for every .components-form-Time DOM element.
 */
common.View.create('crud::form.inputs.File', {

    /**
     * Called when DOM is ready.
     */
    onDOMLoad() {
        // Needed for website page block editor, which most of the time won't load the preview of an image.
        setTimeout(() => {
            this.initGui();

            //this.initMultipleUpload();

            this.initSweetalert();

            this.initDeleteFile();
        }, 1);
    },

    initGui() {
        // Create file upload on file field
        this.element
            .find('input[type="file"].dropzone')
            .dropify({
                messages: {
                    'default': 'Sleep hier uw bestand' + (this.element.find('input[type="file"]').attr('multiple') ? '(en)' : '') + ' of klik op dit vak',
                    'replace': 'Sleep hier uw bestand' + (this.element.find('input[type="file"]').attr('multiple') ? '(en)' : '') + ' of klik op dit vak om het te vervangen',
                    'remove': 'Verwijderen',
                    'error': 'Het zier er naar uit dat er iets fout is gegaan'
                },
                tpl: {
                    message: '<div class="dropify-message"><svg xmlns="http://www.w3.org/2000/svg" class="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" /></svg> <p>{{ default }}</p></div>',
                }
            })
            .end();
    },

    initMultipleUpload() {
        this.element.find('input[type="file"]')
            .on('change', (event) => {
                // Get current file target
                let target = event.currentTarget, mainElement = this;

                // If multiple attribute is found
                if ($(target).attr('multiple')) {
                    this.uploadMultipleFilesAjax(target, mainElement);
                }
            });
    },

    /**
     * Sweet alert options
     */
    initSweetalert() {

        $('.openSwal')

            // Enable sweetalert button (always)
            .prop('disabled', false)

            // Show preview in (sweet)alert
            .on('click', (event) => {
                // Get event target, file and extension
                var $this = $(event.currentTarget),
                    file = $this.data('file'),
                    extension = $this.data('extension');

                // Sweetalert popup
                Swal.fire({
                    html: file && (extension == 'application/pdf' || extension == 'pdf') ?
                        '<embed src="' + file + '" width="100%" height="500" />'
                        : '<img class="img-fluid mb-3" src="' + file + '" />',
                    heightAuto: false,
                    width: '95%'
                });
            });
    },

    initDeleteFile() {
        let drEvent = this.element.find('input[type="file"]');

        drEvent.on('dropify.afterClear', function (event, element) {
            $('#removeFile').val('');
        });
    },

});
